module.exports = __webpack_public_path__ + "static/media/35.5238db03.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/poinkos/35.jpg
// module id = 568
// module chunks = 0